import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

function UserDashboardCardComponent(
    {
        color = 'green',
        text = '',
        value= '0',
        comment= '',
        icon = 'cloud_upload'
    }) {
    
    const [colorValue, setcolorValue] = useState('#000');

    useEffect(() => {
        if ( color === "green") {
            setcolorValue('#166534');
        } else if ( color === "blue") {
            setcolorValue('#01415c');
        } else if ( color === "red") {
            setcolorValue('#B91c1c');
        } else if ( color === "black" ) {
            setcolorValue('#282C34');
        } else if ( color === "gray" ) {
            setcolorValue('#707070');
        } else if ( color === "orange" ) {
            setcolorValue('#f97316');
        }
    }, [color]);
    
  return (
    <div className='flex flex-col w-full bg-white border border-solid border-slate-300 ' style={{minWidth: '200px'}}>
        <div className='flex flex-row p-5 flex-auto'>
            <div className='w-4/6 flex flex-col justify-center'>
                <div className='font-bold text-2xl' style={{color: colorValue }}>{value}</div>
                <div className='font-bold text-sm' style={{ color: 'slategray' }}>{comment}</div>
            </div>
            <div className='w-2/6 flex justify-center items-center text-center'>
                <i style={{ fontSize:36, color: 'slategray' }} className="material-icons-outlined">{ icon }</i>
            </div>
        </div>
        <div className='text-white p-1 text-left font-bold px-4'
            style={{ backgroundColor: colorValue }} >
            {text}
        </div>
    </div>
  )
}


// UserDashboardCardComponent.defaultProps = {
//     color : 'green',
//     text : '',
//     value: '0',
//     comment: '',
//     icon : 'cloud_upload'
// }

UserDashboardCardComponent.propTypes = {
    color: PropTypes.oneOf(['green', 'blue', 'red', 'black', 'gray', 'orange']),
    text: PropTypes.string,
    value: PropTypes.string,
    comment: PropTypes.string,
    icon : PropTypes.string
}

export default UserDashboardCardComponent;